import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="bg-white text-gray-800">
      <div
            className="relative w-full h-[150px] sm:h-[200px] md:h-[250px] mb-3 bg-cover bg-center overflow-hidden"
            style={{
              backgroundImage: `url(${require("../../assets/images/home/img_bag.jpg")})`,
            }}
          >
            {/* Black overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-white text-center p-4">
              {/* Page Title */}
              <h2 className="text-2xl sm:text-3xl md:text-4xl mb-2 tracking-wide">
                Privacy Policy
              </h2>
    
              {/* Breadcrumb */}
              <nav className="flex items-center space-x-2 text-sm text-gray-200 bg-black/40 px-4 py-2 rounded-md max-w-fit mx-auto">
                <Link to="/" className="hover:text-white">
                  Home
                </Link>
                <span>/</span>
                <span>Privacy Policy</span>
              </nav>
            </div>
          </div>
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* ====== Breadcrumb and Title Section ====== */}
        {/* Main content container */}
        <div className="space-y-12 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Introduction
            </h2>
            <p>
              At Luggaelegacy, accessible from{" "}
              <a href="https://luggaelegacy.com" className="text-black font-semibold hover:underline">
                https://luggaelegacy.com
              </a>
              , one of our main priorities is the privacy of our visitors. This
              Privacy Policy document contains the types of information that is
              collected and recorded by Luggaelegacy and how we use it. If you
              have additional questions or require more information, do not hesitate
              to contact us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Consent
            </h2>
            <p>
              By using our website, you hereby consent to our Privacy Policy and
              agree to its terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Information We Collect
            </h2>
            <p className="mb-4">
              The personal information that you are asked to provide, and the
              reasons why you are asked to provide it, will be made clear to you at
              the point we ask you to provide your personal information.
            </p>
            <p className="mb-4">
              If you contact us directly, we may receive additional information
              about you such as your name, email address, phone number, the contents
              of the message and/or attachments you may send us, and any other
              information you may choose to provide.
            </p>
            <p>
              When you register for an account, we may ask for your contact
              information, including items such as name, company name, address,
              email address, and telephone number.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              How We Use Your Information
            </h2>
            <p className="mb-4">
              We use the information we collect in various ways, including to:
            </p>
            <ul className="list-disc list-outside pl-5 space-y-2">
              <li>Provide, operate, and maintain our website</li>
              <li>Improve, personalize, and expand our website</li>
              <li>Understand and analyze how you use our website</li>
              <li>Develop new products, services, features, and functionality</li>
              <li>
                Communicate with you, either directly or through one of our
                partners, for customer service, updates, and marketing purposes
              </li>
              <li>Send you emails</li>
              <li>Find and prevent fraud</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Log Files & Cookies
            </h2>
            <p className="mb-4">
              Luggaelegacy follows a standard procedure of using log files. This is a
              part of hosting services' analytics and is not linked to any personally
              identifiable information. The purpose of this information is to analyze trends,
              administer the site, and gather demographic information.
            </p>
            <p>
              Like any other website, Luggaelegacy uses 'cookies'. These cookies are used to
              store information including visitors' preferences, and the pages on the
              website that the visitor accessed or visited. The information is used to
              optimize the users' experience by customizing our web page content.
            </p>
          </section>

          {/* You can continue to add other sections like GDPR, CCPA, etc. in the same format */}

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;